<template>
  <div class="block bg-white d-flex flex-column align-items-end">
    <div class="common-modal-header text-modal-header d-flex flex-column align-items-start">
      <div class="default-column-name">
        <span class="default-column-title"> {{columnName}} </span>
      </div>
      <div v-if="!disableChangeColumnName" class="editLabel d-flex flex-row align-items-center" @click="onEditLabelHeader">
        <div class="optionEditLabel">
          <i class="material-icons material-icons-outlined icon_edit">
            edit
          </i>
          <span class="text">表示名を変更</span>
        </div>
      </div>
      <div v-if="!disableChangeColumnName" class="line"></div>
      <div
        v-if="!hideSortOrder"
        :class="[
          { active: this.form.sortBy == 1 },
          'sortByAsc d-flex flex-row align-items-center'
        ]"
        @click="onSortByAsc"
      >
        <div class="optionSort">
          <i class="material-icons material-icons-outlined arrow_upward">
            arrow_upward
          </i>
          <span class="text">A to Zで並べ替え</span>
        </div>
      </div>
      <div
        v-if="!hideSortOrder"
        :class="[
          { active: this.form.sortBy == 2 },
          'sortByDesc d-flex flex-row align-items-center'
        ]"
        @click="onSortByDesc"
      >
        <div class="optionSort">
          <i class="material-icons material-icons-outlined arrow_downward">
            arrow_downward
          </i>
          <span class="text">Z to Aで並べ替え</span>
        </div>
      </div>
    </div>
    <div v-if="!hideSortOrder" class="line"></div>
    <div
      class="
        text-modal-body
        d-flex
        flex-column
        align-items-start
        justify-content-center
      "
    >
    <!-- INPUT TEXT -->
      <input
        type="search"
        placeholder="絞り込みテキスト"
        class="form-control inputText"
        v-model="form.textData"
        @keydown.enter="onSubmit"
      />
    </div>
    <div
      class="
        text-modal-footer
        d-flex
        flex-row
        align-items-center
        justify-content-center
      "
    >
      <b-button variant="info" class="btnSubmit" @click.prevent="onSubmit">
        OK
      </b-button>
    </div>
  </div>
</template>

<script>
const SORT_ASC_MODE = 1
const SORT_DESC_MODE = 2
export default {
  data() {
    return {
      form: {
        isItemNo: this.isItemNo,
        sortBy: null,
        textData: ''
      },
      columnName: this.defaultItemName
    }
  },
  props: ['isItemNo', 'queryPrameterValue', 'defaultItemName', 'disableChangeColumnName', 'hideSortOrder'],
  watch: {
    isItemNo: {
      handler: function (newValue, oldValue) {
        this.form.isItemNo = newValue
      }
    },
    queryPrameterValue: {
      handler: function (newValue, oldValue) {
        if (newValue[this.isItemNo]) {
          this.form.textData = newValue[this.isItemNo]
        }
      },
      deep: true
    }
  },
  methods: {
    onSortByAsc() {
      this.form.sortBy = this.toggleSort(SORT_ASC_MODE)
      this.$emit('on-sort', {order: this.form.sortBy, propetyName: this.getPropertyNameBySort(this.form.sortBy)})
    },
    resetValueComponent() {
      this.form.textData = this.queryPrameterValue[this.form.isItemNo]
    },
    initValueComponent(sort, isItemNo) {
      this.form.textData = this.queryPrameterValue[isItemNo]
      if (sort.propetyName === isItemNo) {
        this.form.sortBy = sort.order
      } else {
        this.form.sortBy = null
      }
    },
    onSortByDesc() {
      this.form.sortBy = this.toggleSort(SORT_DESC_MODE)
      this.$emit('on-sort', {order: this.form.sortBy, propetyName: this.getPropertyNameBySort(this.form.sortBy)})
    },
    onSubmit() {
      this.queryPrameterValue[this.form.isItemNo] = this.form.textData
      this.$emit('on-submit', this.queryPrameterValue)
    },
    onEditLabelHeader() {
      this.$emit('allow-edit-label')
    },
    toggleSort(value) {
      if (this.form.sortBy !== value) {
        return value
      }
      return null
    },
    getPropertyNameBySort(sortBy) {
      return sortBy ? this.form.isItemNo : null
    }
  }
}
</script>

<style lang="scss" scoped>
.block {
  padding: 4px 1px 4px 8px;
  width: 280px;
  height: auto;
  cursor: default;
}
.text-modal-header {
  left: 8px;
  top: 4px;
}
.line {
  width: 272px;
  height: 1px;
  left: 8px;
  top: 92px;
  margin: 8px 0px;
  background: $line_gray;
}
.text-modal-body {
  padding: 8px 8px 8px 4px;
  width: 272px;
  min-height: 54px;
}
.text-modal-footer {
  padding: 8px;
  width: 272px;
  height: 58px;
  .btnCancel {
    padding-right: 35px;
    font-style: normal;
    font-weight: normal;
    @include responsive-fs(12);
    line-height: 160%;
    color: #4e66a6;
    &:hover {
      text-decoration: none;
    }
  }
}
.arrow_downward, .arrow_upward {
  @include responsive-fs(15);
}
.icon_edit {
  @include responsive-fs(14);
}
</style>



// WEBPACK FOOTER //
// src/components/custom-components/TextFilterSortModal.vue